module.exports = require("react-dev-utils/FileSizeReporter");